import { AGENT_ALIASES, AgentId } from '@/constants/agentNames'

/** The agent whose words the workflow chat carries: the plant-support persona, as the old chat named it. */
export const AGENT_NAME = AGENT_ALIASES[AgentId.PLANT_SUPPORT]?.displayName ?? 'AI Plant Support Engineer'
